export const data = {
    name: "Tests",
    layout: [],
};
export default data;